import React from "react";
import css from './UploadFile.module.css';
import { useEffect, useState } from "react";
import axios from "axios";
import './UploadFile.module.css';
import {Button} from "@mui/material";
import clsx from "clsx";

export const UploadFile = (
    {
        token,
        targetUrl
    }
) => {
    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleFileUpload = async () => {
        if (!selectedFile) {
            alert("Proszę wybrać plik przed wysłaniem.");
            return;
        }
        const formData = new FormData();
        formData.append("file", selectedFile);

        try {
            const response = await axios.post(targetUrl, formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/pdf",
                },
            }).then((res) => {
                const data = res.data;
                alert(data)
            }).catch((err) => {
                alert("Wiadomość z serwera: " + err.response.data
                    + "\n" + "Operacja nie udana");
            });
        } catch (error) {
            console.error("Błąd podczas przesyłania pliku:", error);
        }
    };

    return (
        <div className={clsx(css.uploadFile)}>
            <h2>Prześlij plik</h2>
            <div className={clsx(css.fileArea)}>
                <input type="file" onChange={handleFileChange} />
            </div>
                <Button className={clsx(css.send)} onClick={handleFileUpload}>Wyślij</Button>
        </div>

    );

}